export const validateMobile = (mobile) => {
  // Exactly 10 digits
  // First digit cannot be 0 or 1
  // No repeating same digit pattern (e.g., 9999999999)
  const regex = /^(?!([0-9])\1{9})[2-9][0-9]{9}$/;
  return regex.test(mobile);
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return regex.test(email);
};

export const validateWebsite = (url) => {
  const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
  return regex.test(url);
};

export const validateTwoDigitNumber = (value) => {
  const regex = /^[0-9]{0,2}$/;
  return regex.test(value);
};

export const validateNumber = (value) => {
  return /^\d+$/.test(value); // only digits
};

export const validateBudget = (value) => {
  return /^\d+(\.\d+)?\s?(k|l|cr|lakh|crore)?$/i.test(value.trim());
};

export const validatePincode = (value) => {
  return /^\d{6}$/.test(value);
};

export const validateNumberWithLimit = (maxDigits) => {
  return (value) => {
    if (value === "") return true; // allow empty while typing
    return validateNumber(value) && value.length <= maxDigits;
  };
};

export const validateOTP = validateNumberWithLimit(6); // 6 digit OTP

